import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from 'src/app/common/services/api.service';
import { TranslateService } from '@ngx-translate/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-claims',
  templateUrl: './claims.component.html'
})
export class ClaimsComponent implements OnInit {

    @Input() clientKey: any;
    @Input() displayHeader: boolean = true;
    claims:any = [];

    constructor(public translate: TranslateService,
                private apiService: ApiService) {
    }

    ngOnInit() {
        if (this.clientKey)
            this.getClaims(); 
    }

    getClaims() {
        var model = {
            ClientKey: this.clientKey,
            PageSize: 100,
            SortOrder: 'Desc',
            SortField: ''
        };

        this.apiService.post("Api/ClaimAPI/Search/", model).subscribe((result: any) => {
            var claims = [];
            for (var claimKey in result.rows) {
                claims.push(result.rows[claimKey]);
            }
            this.claims = claims;
        });
    }

    //Used for scrollable cards
    public config: PerfectScrollbarConfigInterface = {
        suppressScrollX: false,
        wheelPropagation: false,
        useBothWheelAxes: true
    };

}
